export default __webpack_public_path__ + "static/media/fauna-mobile.7a1da44c.png";